import AlertService from './alert_service.js'

const alertService = new AlertService();
export default class GeneralService {
	showRequestErrors(error, modal) {
		if(error.status != 403) {
			if (error.body.status && error.body.status == 'ERROR') {
				alertService.showAlert(modal, 'danger', 'Error!', error.body.message);
			} else {
				alertService.showAlert(modal, 'danger', 'Error!', error.statusText);
			}
		}
	}
	toSeoUrl(url) {
		return url.toString()   
			.toLowerCase()                  // Convert to string
			.normalize('NFD')               // Change diacritics
			.replace(/[\u0300-\u036f]/g,'') // Remove illegal characters
			.toLowerCase()                  // Change to lowercase
			.replace(/\s+/g,'-')            // Change whitespace to dashes
			.replace(/&/g,'-and-')          // Replace ampersand
			.replace(/[^-a-z0-9]/g,'')     // Remove anything that is not a letter, number or dash
			.replace(/-+/g,'-')             // Remove duplicate dashes
			.replace(/^-*/,'')              // Remove starting dashes
			.replace(/-*$/,'');             // Remove trailing dashes
	}
	toDateHourDMY(value) {
		let dateFormat = '';
		if(value != "" && value.length > 10) {
			dateFormat = value.substr(0,10);
			dateFormat =  dateFormat.split('-');
			dateFormat = dateFormat.length < 3 ? '' : dateFormat[2] + "/" + dateFormat[1] + "/" + dateFormat[0];
			dateFormat = dateFormat + value.substr(10);
		}
		return dateFormat;
	}
	calculaEdad(fecha) {
		if(this.fechaValida(fecha)) {
			let hoy = new Date();
			let cumpleanos = new Date(fecha);
			let edad = hoy.getFullYear() - cumpleanos.getFullYear();
			if(edad > 150) return "";
			let m = hoy.getMonth() - cumpleanos.getMonth();
	
			if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
				edad--;
			}
			return edad;
		}
		return "";
	}
	fechaValida(fecha){
		let valid = !isNaN(Date.parse(fecha));
		return valid;
	}
	fechaSpanish(fecha) {
		let fechaArray = fecha.split("-");
		if(fechaArray.length != 3) {
			return fecha;
		}
		return fechaArray[2].substr(0, 2) + '/' + fechaArray[1] + '/' + fechaArray[0];
	}
	eliminarDiatricos(texto) {
		if(texto) {
			return texto.normalize('NFD')
			.replace(/([aeio])\u0301|(u)[\u0301\u0308]/gi,"$1$2")
			.normalize();
		}
		return '';
	}
	customSelectSearch(options, search) {
		let generalService = new GeneralService();
		let formatedSearch = generalService.eliminarDiatricos(search).toLowerCase()
		let filtered = options.filter(o => generalService.eliminarDiatricos(o.descripcionDatoParametrico).toLowerCase().includes(formatedSearch));
		return filtered;
	}
}